interface Kind {
    name: string;
    abbr: string;
    look: string;
    lo?: number;
    hi: number;
}

export default class Room {

    constructor( public id: number,
                 public name: string,
                 public floor: string,
                 public kind: Kind ) {
    }

}



/** WEBPACK FOOTER **
 ** ./src/models/Room.ts
 **/